import { TSelectOption } from "@minuthq/meatball-ui-react"

import { useFetchParadiseLLMPromptCategories } from "src/data/paradise/paradiseLLMPrompts/queries/paradiseLLMPromptsQueries"
import { TParadiseLLMPromptCategory } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"

export function useParadiseLLMPromptCategoryOptions() {
  const {
    data: response,
    isLoading,
    error,
  } = useFetchParadiseLLMPromptCategories()

  const categoryOptions: TSelectOption<string>[] =
    response?.categories.map(
      (category: { llm_category: TParadiseLLMPromptCategory }) => ({
        label: formatCategoryLabel(category.llm_category),
        value: category.llm_category,
      })
    ) ?? []

  return {
    categoryOptions,
    isLoading,
    error,
  }
}

function formatCategoryLabel(category: TParadiseLLMPromptCategory): string {
  return category
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
